import BookOpen from 'plaid-threads/Icons/BookOpen';
import Link from 'plaid-threads/Icons/Link';
import Video from 'plaid-threads/Icons/Video';

import { decodeHtmlEntities } from 'src/lib/decode-html-entities';

import styles from './ChatSources.module.scss';
import { RESOLUTION_BASE } from './linkSafety';
import { Source } from './types';

const VIDEO_HOSTS = new Set([
  'youtube.com',
  'www.youtube.com',
  'm.youtube.com',
  'youtu.be',
]);

// Read from the parsed host and path, not a substring of the whole URL, so a
// query string mentioning youtube.com does not pick up the video icon
const iconFor = (url: string) => {
  let parsed: URL;
  try {
    parsed = new URL(url, RESOLUTION_BASE);
  } catch {
    return <Link className={styles.smallishIcon} />;
  }

  if (VIDEO_HOSTS.has(parsed.hostname)) {
    return <Video className={styles.smallishIcon} />;
  }
  if (parsed.pathname.toLowerCase().endsWith('.pdf')) {
    return <BookOpen className={styles.smallishIcon} />;
  }
  return <Link className={styles.smallishIcon} />;
};

// This is a ChatSources component that takes in a list of sources and renders them as a list of links
interface Props {
  sources: Array<Source>;
}
const ChatSources = ({ sources }: Props) => {
  return (
    <div className={styles.chatSources}>
      <div className={styles.sourcesTitle}>REFERENCES</div>
      <ul className={styles.sourcesList}>
        {sources.map((source: { url: string; title: string }, index) => {
          return (
            <li className={styles.sourcesListItem} key={index}>
              <a
                className={styles.sourcesListItemAnchor}
                href={source.url}
                target='_blank'
                rel='noopener noreferrer'
              >
                <span className={styles.sourcesListText}>
                  {source.title ? decodeHtmlEntities(source.title) : null}
                </span>
              </a>
              {iconFor(source.url)}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

ChatSources.displayName = 'ChatSources';
export default ChatSources;
